import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaShoppingCart,
  FaRupeeSign,
  FaSignOutAlt,
  FaChevronDown,
  FaBox,
  FaShareAlt,
  FaLink,
} from "react-icons/fa";
import Logo from "../assets/images/icons/logo1.png";

const ReSellerSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);

  const logout = () => {
    localStorage.removeItem("ReSellerTokenData");
    localStorage.removeItem("role");
    navigate("/ReSellerLogin");
  };
  const resellerMenu = [
    {
      label: "Dashboard",
      icon: FaHome,
      path: "/reseller/dashboard",
    },
    {
      label: "Orders",
      icon: FaShoppingCart,
      children: [
        { label: "All Orders", path: "/reseller/orders" },
        { label: "Wallet", path: "/reseller/wallet" },
        { label: "Withdraw Requests", path: "/reseller/GetReWithdrowRequest" },
      ],
    },
    {
      label: "Product",
      icon: FaBox,
      children: [
        { label: "View Products", path: "/reseller/viewProduct" },
        // { label: "Resell Products", path: "/reseller/ResellProduct" },
        { label: "My Products", path: "/reseller/MyProduct" },
      ],
    },
  ];

  const menuClass =
    "flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-orange-200 transition";

  const activeClass = "bg-orange-500 text-white hover:bg-orange-600";

  return (
    <aside
      className={`
  fixed top-0 left-0 h-screen w-64 bg-white border-r z-50 flex flex-col
  transform transition-transform duration-300
  ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
  md:translate-x-0
`}
    >
      {/* Logo */}
      <div className="p-4 flex items-center gap-3 border-b shrink-0">
        <img
          src={Logo}
          alt="Logo"
          className="w-10 h-10 object-contain border-2 border-orange-500 rounded-full p-1"
        />
        <span className="text-xl font-bold text-orange-500">
          Reseller Panel
        </span>
      </div>

      {/* Menu */}
      <nav className="flex-1 overflow-y-auto p-6">
        {resellerMenu.map((item, index) => {
          const Icon = item.icon;

          if (!item.children) {
            return (
              <NavLink
                key={index}
                to={item.path}
                onClick={() => setSidebarOpen(false)}
                className={({ isActive }) =>
                  isActive ? `${menuClass} ${activeClass}` : menuClass
                }
              >
                <Icon /> {item.label}
              </NavLink>
            );
          }

          return (
            <div key={index}>
              <button
                onClick={() => setOpenMenu(openMenu === index ? null : index)}
                className={`${menuClass} w-full justify-between`}
              >
                <span className="flex items-center gap-3">
                  <Icon /> {item.label}
                </span>
                <FaChevronDown
                  className={`transition ${
                    openMenu === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openMenu === index && (
                <div className="ml-8 mt-1 space-y-1">
                  {item.children.map((child, i) => (
                    <NavLink
                      key={i}
                      to={child.path}
                      onClick={() => setSidebarOpen(false)}
                      className={({ isActive }) =>
                        isActive
                          ? "block px-3 py-2 rounded-md bg-orange-100 text-orange-600"
                          : "block px-3 py-2 rounded-md text-gray-600 hover:bg-orange-50"
                      }
                    >
                      {child.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t shrink-0">
        <button
          onClick={logout}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition"
        >
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </aside>
  );
};

export default ReSellerSidebar;
